import React from "react";
import { LockKeyhole, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export function KycHeader() {
  const { t } = useTranslation();

  return (
    <header className="relative z-20 pt-[env(safe-area-inset-top)]">
      <div className="kyc-header-inner mx-auto flex h-14 w-full max-w-3xl items-center justify-between px-4 sm:h-20 sm:px-2">
        <div
          className="flex items-center gap-2.5"
          aria-label={t("kyc.portal.brand")}
        >
          <span className="flex size-8 items-center justify-center rounded-lg border border-white/15 bg-white/10 text-teal-300 backdrop-blur-sm">
            <ShieldCheck
              className="size-[1.125rem]"
              strokeWidth={2.2}
              aria-hidden="true"
            />
          </span>
          <span className="text-sm font-semibold tracking-[-0.015em] text-white">
            {t("kyc.portal.brand")}
          </span>
        </div>

        <div className="flex items-center gap-1.5 text-xs font-medium text-slate-300">
          <LockKeyhole
            className="size-3.5 text-teal-300"
            strokeWidth={2}
            aria-hidden="true"
          />
          <span className="hidden sm:inline">
            {t("kyc.portal.secureFooter")}
          </span>
          <span className="sr-only sm:hidden">
            {t("kyc.portal.secureFooter")}
          </span>
        </div>
      </div>
    </header>
  );
}
